/* eslint-disable @next/next/no-img-element */
import React, { FC } from 'react'

import styles from './Previewer.module.scss'

interface PreviewerProps {
  url: string
  format: string
}

enum FileFormat {
  PDF = 'application/pdf',
  IMAGE = 'image/',
  VIDEO = 'video/',
}

const Previewer: FC<React.PropsWithChildren<React.PropsWithChildren<PreviewerProps>>> = ({ url, format }) => {
  return (
    <div className={styles.root}>
      {format.includes(FileFormat.IMAGE) && <img className={styles.img} src={url} alt="preview" />}
      {format.includes(FileFormat.VIDEO) && (
        <video className={styles.video} src={url} controls>
          <track kind="captions" />
        </video>
      )}
      {format.includes(FileFormat.PDF) && <embed className={styles.pdf} type={FileFormat.PDF} src={url} />}
    </div>
  )
}

export default Previewer
